import styled from '@emotion/styled';
import { Box, Typography, Rating } from '@mui/material';

const ServiceContainer = styled(Box)``;

const ServiceTitle = styled(Typography)`
  font-size: 6.6vw;
  line-height: 9.2vw;
  color: #383838;
  @media (orientation: landscape) {
    font-size: 3.3vw;
    line-height: 3.9vw;
  }
`;

const VendorContainer = styled(Box)`
  margin-top: 3.6vw;
  @media (orientation: landscape) {
    margin-top: 0.4vw;
  }
`;

const VendorTitle = styled(Typography)`
  font-size: 4.8vw;
  line-height: 6.7vw;
  color: #383838;
  opacity: 0.7;
  @media (orientation: landscape) {
    font-size: 2.4vw;
    line-height: 2.9vw;
  }
`;

const QuestionContainer = styled(Box)`
  margin-top: 1.6vw;
  display: flex;
  flex-direction: row;
  @media (orientation: landscape) {
    margin-top: 2.4vw;
  }
`;

const QuestionTitle = styled(Typography)`
  font-size: 4.4vw;
  line-height: 6.4vw;
  @media (orientation: landscape) {
    font-size: 2.2vw;
    line-height: 3vw;
  }
`;

const QuestionDescription = styled(Typography)`
  font-size: 4.4vw;
  line-height: 6.4vw;
  @media (orientation: landscape) {
    font-size: 2.2vw;
    line-height: 3vw;
  }
`;

const RateContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 2.9vw;
  margin-top: 4.7vw;
  @media (orientation: landscape) {
    margin-top: 2.3vw;
    justify-content: start;
    & > *:not(:last-child) {
      margin-right: 5.4vw;
    }

    align-items: center;
  }
`;

const Rate = styled(Rating)``;

const Score = styled(Typography)`
  color: #383838;
  font-size: 6.3vw;
  line-height: 8.8vw;
  @media (orientation: landscape) {
    font-size: 3.2vw;
    line-height: 4.5vw;
  }
`;

export {
  ServiceContainer,
  ServiceTitle,
  VendorContainer,
  VendorTitle,
  QuestionContainer,
  QuestionTitle,
  QuestionDescription,
  RateContainer,
  Rate,
  Score,
};
